module.exports = __webpack_public_path__ + "static/2_1_search-2_MT-884a3f750c737ec1cc83dd3629df31df.svg";